import { Component, inject, input, Signal } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  private translateService = inject(TranslateService)

  message: Signal<string> = input(this.translateService.instant('CommonTexts.pleaseWait'))
  showInline = input(false)
  showSmall = input(false)
  showText = input(true)
}
